/**
 * @generated SignedSource<<82b6d78e2cca4bce488634c1b9c1752a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkbookDeleteInput = {
  id: string;
};
export type WorkbookId_workbookDeleteMutation$variables = {
  input: WorkbookDeleteInput;
};
export type WorkbookId_workbookDeleteMutation$data = {
  readonly workbookDelete: {
    readonly id: string;
  };
};
export type WorkbookId_workbookDeleteMutation = {
  response: WorkbookId_workbookDeleteMutation$data;
  variables: WorkbookId_workbookDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkbookId_workbookDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workbook",
        "kind": "LinkedField",
        "name": "workbookDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkbookId_workbookDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workbook",
        "kind": "LinkedField",
        "name": "workbookDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82cf729f2a57fc53a373ca66bad8de98",
    "id": null,
    "metadata": {},
    "name": "WorkbookId_workbookDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation WorkbookId_workbookDeleteMutation(\n  $input: WorkbookDeleteInput!\n) {\n  workbookDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "53ad2ce515e2afa63a5cf4d2dee0b632";

export default node;
